import React, { useContext, useEffect } from "react";
import { Col, Row, Form, Input, message, Card, Select, Tooltip, Switch, Button, Radio, Modal } from "antd";
import { useNavigate } from "react-router-dom";
import "dayjs/locale/en";
import { AuthContext } from "../../Auth/AuthContext";
import { addRole, getAllrole, getallRolePermissions } from "../../utils/API";
import { ArrowLeftOutlined } from "@ant-design/icons";
const { Option } = Select;

interface AddrolemodalProps {
  visible: boolean;
  onClose: () => void;
  onSuccess?: () => void;
  customerId?: string; // Make optional if not always required
  onTaskCreated?: () => void; // Make optional if not always required
}
const Addrolemodal: React.FC<AddrolemodalProps> = ({
  visible,
  onClose,
  onSuccess,
  customerId,
  onTaskCreated,
}) => {
  const navigate = useNavigate();

  const { authData } = useContext(AuthContext);
  const [form] = Form.useForm(); // Use Form hook to get form instance
  const [isLoading, setIsLoading] = React.useState(false);
  const roleId = authData.roleId;
  const [roles, setRoles] = React.useState<any[]>([]);

  useEffect(() => {
    const fetchRoles = async () => {
      try {
        const res = await getallRolePermissions("");
        setRoles(res?.data || []);   // ✅ ensure array
      } catch (err) {
        console.error("Error fetching roles:", err);
        setRoles([]); // fallback
      }
    };
    fetchRoles();
  }, []);

  const handleSubmit = async (values: any) => {
    try {
      setIsLoading(true);

      // Slug
      const slug = values.name.toLowerCase().replace(/\s+/g, "-");

      // Send all values (including cloneRoleId if selected)
      const payload = { ...values, slug };

      const response = await addRole(payload);

      message.success("Role added successfully!");
      onClose?.();
      onSuccess?.();
      form.resetFields();
    } catch (error) {
      console.error("API Error:", error);
      message.error("Failed to add role");
    } finally {
      setIsLoading(false);
    }
  };



  return (
    <Modal

      visible={visible}
      onCancel={onClose}
      footer={null}
      width={500}
      centered={false} // Disable centered to use top positioning
      destroyOnClose
      className="custom-modal"
      style={{
        bottom: 20,
        top: 20,
        maxHeight: 'calc(100vh - 3  0px)', // Leaves 20px space at bottom
        margin: '0 auto',
        position: 'relative',
        // paddingBottom: 20 // Adds space inside modal at bottom
      }}
      bodyStyle={{
        // maxHeight: 'calc(90vh - 55px)',
        overflowY: 'auto',
        // padding: '20px',
        fontFamily: "inter, sans-serif",
      }}
      styles={{
        header: {
          padding: "12px",
          position: "sticky",
          top: 0,
          backgroundColor: "#f1f5ffff",
        },
        content: {
          padding: 0,
          overflow: "hidden",
        },
      }}
      title={
        <div
          style={{
            color: "#4b5563",
            fontFamily: "inter, sans-serif",
            fontSize: "20px",
            fontWeight: 500,
          }}
        >
          Create New Developer
        </div>
      }
    >
      <Form
        onFinish={handleSubmit}
        form={form}
        labelCol={{ span: 6 }}
        wrapperCol={{ span: 18 }}
        colon={false}
        style={{ margin: 0 }}
      >
        <div className="elements">
          {/* Role Input */}

          <Form.Item
            name="name"
            required={false}
            label={<span style={{
              color: '#4b5563',
              fontFamily: 'inter, sans-serif',
              fontSize: '14px',
              paddingLeft: "15px",
              fontWeight: 500,
            }}>Role<span className="text-danger"> *</span></span>}
            rules={[{ required: true, message: "Please Enter Role" }]}
          >
            <Input
              size="large"
              disabled={Number(roleId) === 2}
              className="rounded border border-1"
              placeholder="Enter Role"
            />
          </Form.Item>



          {/* Role ID Input */}
          <Form.Item
            name="roleId"
            required={false}
            label={<span style={{
              color: '#4b5563',
              fontFamily: 'inter, sans-serif',
              fontSize: '14px',
              paddingLeft: "15px",
              fontWeight: 500,
            }}>Role Id<span className="text-danger"> *</span></span>}
            rules={[{ required: true, message: "Please Enter Role ID" }]}
          >
            <Input
              size="large"
              disabled={Number(roleId) === 2}
              className="rounded border border-1"
              placeholder="Enter Role ID"
            />
          </Form.Item>

          <Form.Item
            name="cloneRoleId"
            label={
              <span
                style={{
                  color: "#4b5563",
                  fontFamily: "inter, sans-serif",
                  fontSize: "14px",
                  paddingLeft: "15px",
                  fontWeight: 500,
                }}
              >
                Base Role
              </span>
            }
          >
            <Select
              size="large"
              placeholder="Select role to copy permissions"
              allowClear
              showSearch
              options={(roles).map((role: any) => ({
                value: role?.roleId?._id,
                label: role?.roleId?.name,
              }))}
            />
          </Form.Item>

        </div>

        {/* Submit Button */}
        <Row justify="end">
          <Col
            xs={24}
            sm={24}
            md={24}
            xl={24}
            xxl={20}
            className="d-flex justify-content-end me-3"
          >
            <div className="button-wrapper">
              <button
                className="allcanclebutton"
                onClick={onClose}
                type="button"
                disabled={isLoading}
              >
                Cancel
              </button>

              <button className="allsubmitebutton"
                type="submit"
                disabled={isLoading}>
                {isLoading ? "Add Role..." : "Add Role"}
              </button>
            </div>
          </Col>
        </Row>


      </Form>
    </Modal >
  );
};

export default Addrolemodal;
